import { IRoute }   from "./route";

export default class Routes {
    private map = new Map<string, IRoute>();

    constructor() { }

    public add(key: string, route: IRoute): void {
        this.map.set(key, route);
    }

    public find(key: string): IRoute | undefined {
        return this.map.get(key);
    }

    public exists(key: string): boolean {
        return this.map.has(key);
    }

    public keys(): IterableIterator<string> {
        return this.map.keys();
    }

}



